




























































import { SysUser } from "@/types/api-beans";
import html2canvas from "html2canvas";
import Vue from "vue";
import detailStyle from "./detailStyle.vue";

export default Vue.extend({
  components: { detailStyle },
  props: {
    accident: { type: Object, required: true }
  },
  // watch:{
  //   'accident.videoUrl':{
  //     handler(val) {
  //       if (val) {
  //         const url = 'https:' + val.split(':')[1];
  //         this.$set(this.accident,'videoUrl',url);
  //       }
  //     },
  //     immediate: true,
  //     deep:true
  //   }
  // },
  methods: {
    /**
     * 截图
     */
    screenShot() {
      return new Promise((resolve, reject) => {
		  console.log('video',(this.$refs as any).target)
        if (!(this.$refs as any).target) {
          this.$message.error("未获取到视频信息");
          reject(new Error("未获取到视频信息"));
        } else {
          let canvas: any;
          let video: any = (this.$refs as any).target;
          canvas = document.createElement("canvas");
          canvas.setAttribute("id", "video-canvas");
          canvas.setAttribute("display", "display: none;");
          var context = canvas.getContext("2d");
          canvas.width = 730;
          canvas.height = 600;
          context.drawImage(video, 0, 0, 730, 600);
          resolve(canvas.toDataURL().replace(/^data:image\/\w+;base64,/, ""));
          // html2canvas((this.$refs as any).target, {
          //   allowTaint: true
          // }).then(canvas => {
          //   resolve(canvas.toDataURL().replace(/^data:image\/\w+;base64,/, ''));
          // });
        }
      });
    },
    getRoleName(user: any, roles: String) {
      console.log(user);
      return user.find((el: SysUser) => {
        return el.roles?.find(it => it.roleKey === roles);
      })?.nickName;
    }
  }
});
